class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

 

  document.addEventListener('DOMContentLoaded', function () {
    // Function to toggle the checkout button
    function toggleCheckoutButton() {
      const cartTotalElement = document.getElementById('orig-total');
      if (cartTotalElement) {
        const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', ''));
        const checkoutButton = document.getElementById('checkout-button-mini');
        if (cartTotal >= 60) {
          checkoutButton.style.display = 'none'; // always hide the checkout button
        } else {
          checkoutButton.style.display = 'none'; // Hide the checkout button
        }
      }
    }

    // Call the function on page load
    toggleCheckoutButton();

    // Listen for changes to the cart (e.g., item added or removed)
    const cartObserver = new MutationObserver(function () {
      toggleCheckoutButton();
    });

    // Define the DOM element to observe for changes (adjust for your theme)
    const cartContainer = document.querySelector('.cart-drawer-container'); // Replace with your selector for the cart drawer container

    if (cartContainer) {
      // Start observing
      cartObserver.observe(cartContainer, { childList: true, subtree: true });
    }
  });


function updateProgressBar() {
  const cartTotalElement = document.getElementById('orig-total');
  const progressBarContainer = document.querySelector('.progress-bar-container-mini');
  const progressBar = document.querySelector('.progress-bar-mini');
  const progressTitle = document.querySelector('.progress-title-mini');
  const checkoutButton = document.querySelector('#checkout-button-mini');

  if (cartTotalElement) {
    const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', ''));

    if (cartTotal >= 60) {
      // Hide the progress bar and title
      progressBarContainer.style.display = 'none';
      progressTitle.style.display = 'none';
    } else {
      const progress = (cartTotal / 60) * 100;
      progressBar.style.display = 'block';
      progressBar.style.width = progress + '%';
      progressTitle.style.display = 'block';

      if (checkoutButton) {
        if (cartTotal < 60) {
          checkoutButton.style.display = 'block';
        } else {
          checkoutButton.style.display = 'none';
        }
      }
    }
  }
}

// Call the function on page load
updateProgressBar();

// Set up a MutationObserver to watch for changes in the cart
const cartObserver = new MutationObserver(function () {
  updateProgressBar();
});

const cartContainer = document.querySelector('.cart-drawer-container');

if (cartContainer) {
  cartObserver.observe(cartContainer, { childList: true, subtree: true });
}

/*
document.addEventListener('DOMContentLoaded', function () {
    // Function to toggle the checkout button
    function toggleCheckoutButton() {
        const cartTotalElement = document.getElementById('mini-cart-subtotal');
        if (cartTotalElement) {
            const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', ''));
            const checkoutButton = document.getElementById('checkout-button-mini');
            if (cartTotal >= 60) {
                checkoutButton.style.display = 'block'; // Show the checkout button
            } else {
                checkoutButton.style.display = 'none'; // Hide the checkout button
            }
        }
    }

    // Function to update the progress bar
    function updateProgressBar() {
        const cartTotalElement = document.getElementById('mini-cart-subtotal');
        const progressBarContainer = document.querySelector('.progress-bar-container-mini');
        const progressBar = document.querySelector('.progress-bar-mini');
        const progressTitle = document.querySelector('.progress-title-mini');
        const checkoutButton = document.querySelector('#checkout-button-mini');

        if (cartTotalElement) {
            const cartTotal = parseFloat(cartTotalElement.innerText.replace('$', ''));
            if (cartTotal >= 60) {
                // Hide the progress bar and title, but not the container
                progressBar.style.display = 'none';
                progressTitle.style.display = 'none';
                progressBarContainer.style.display = 'none';
            } else {
                const progress = (cartTotal / 60) * 100;
                progressBar.style.display = 'block';
                progressBar.style.width = progress + '%';
                progressTitle.style.display = 'block';
            }

            if (checkoutButton) {
                if (cartTotal < 60) {
                    checkoutButton.style.display = 'none';
                } else {
                    checkoutButton.style.display = 'block';
                }
            }
        }
    }

    // Call the functions on page load
    toggleCheckoutButton();
    updateProgressBar();

    // Listen for changes to the cart (e.g., item added or removed)
    const cartContainer = document.querySelector('.cart-drawer-container'); // Replace with your selector for the cart drawer container

    if (cartContainer) {
        // Start observing
        const cartObserver = new MutationObserver(function () {
            toggleCheckoutButton();
            updateProgressBar();
        });
        cartObserver.observe(cartContainer, { childList: true, subtree: true });
    }
});
*/










